<template>
  <div>
    <div class="d-flex justify-content-center height" v-if="data==null">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">در حال بارگذاری ...</span>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-2">
        <div class="list-group">
          <a
            v-for="(material, name, index) in data"
            :key="index"
            :class="[
              { active: index === 0 },
              'list-group-item list-group-item-action'
            ]"
            :id="'list' + name + '-list'"
            data-toggle="list"
            :href="'#list-' + name"
            role="tab"
            >{{ name }}
          </a>
        </div>
      </div>
      <div class="col-md-10">
        <div class="tab-content" id="nav-tabContent">
          <div
            v-for="(material, name, index) in data"
            :key="index"
            :class="[{ active: index === 0 }, 'tab-pane fade show']"
            :id="'list-' + name"
            role="tabpanel"
            :aria-labelledby="'list-' + name + '-list'"
          >
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>نام</th>
                    <th>مشخصه</th>
                    <th>وضعیت</th>
                    <th>نصاب</th>
                    <th>تنظیمات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(attr, attrIndex) in material" :key="attrIndex">
                    <td v-text="attrIndex+1"></td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-outline-primary"
                        data-toggle="modal"
                        :data-target="'#materialProperty' + attr.id">
                        {{ name }}
                      </button>
                      <attribute :attr="attr" :properties="properties" :attrIndex="attrIndex" :name="name" :property_default="property_default"></attribute>
                    </td>
                    <td v-if="attr.detail && attr.detail.detail">{{ attr.detail.detail}}
                    </td>
                    <td v-else>
                      {{'تعیین نشده'}}
                    </td>
                    <td>
                      <status :statuses="statuses" :attr="attr"></status>
                    </td>
                    <td>
                      <installer :installers="installers" :attr="attr"></installer>
                    </td>
                    <td>
                      <button class="btn btn-outline-danger btn-floating" @click="deleteAttribute(attr.id, name, attrIndex)"><i
                          class="ti-trash"></i></button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th>ردیف</th>
                    <th>نام</th>
                    <th>مشخصه</th>
                    <th>وضعیت</th>
                    <th>نصاب</th>
                    <th>تنظیمات</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <label class="pt-4 px-3">متریال را انتخاب کنید</label>
      <form @submit.prevent="addAttribute()" class="col-12 d-flex">
        <select class="form-control mb-3" v-model="product">
          <option v-for="(material, index) in materials" :key="index" :value="material.id">{{material.name}}</option>
        </select>
        <button class="btn btn-primary btn-floating ml-2" type="submit"><em class="ti-plus"></em></button>
      </form>
    </div>
  </div>
</template>
<script>
import attribute from '@/components/project/material/Attribute.vue'
import status from '@/components/project/material/Status.vue'
import installer from '@/components/project/material/Installer.vue'
export default {
  name: 'Material',
  props: ['data', 'properties', 'materials', 'product', 'statuses', 'installers', 'property_default'],
  components: {
    attribute, status, installer
  },
  methods: {
    addAttribute () {
      if (this.product != null) {
        this.$send.submit('get', 'api/project/' + this.$route.params.id + '/' + this.product)
          .then(response => {
            this.product = null
            if (!this.data[response.name]) {
              if (this.data.length === 0) {
                this.$parent.startMaterial()
              } else {
                this.$parent.startMaterial()
              }
            }
          })
      } else {
        // eslint-disable-next-line no-undef
        swal(
          'خطا!',
          'ابتدا متریالی را انتخاب کنید!',
          'warning', {
            button: 'باشه'
          })
      }
    },
    deleteAttribute (id, name, attrIndex) {
      this.$send.submit('delete', 'api/project/' + id + '/destroy')
        .then(response => {
          this.data[name].splice(attrIndex, 1)

          if (this.data[name].length === 0) {
            delete this.data[name]
          }
        })
    }
  }
}
</script>
